import { Config } from "../core/config/config.js";
import { PointInfo } from "./geomapUtil.js";

export class GeomapRPCService {
    private _tabId: string;
    private _hubProxy: SignalR.Hub.Proxy;
    private _hubConnection: SignalR.Hub.Connection;

    constructor(tabId?: string) {
        this._hubConnection = $.hubConnection(Config.baseUrl + "signalr", { useDefaultPath: false });
        this._hubProxy = this._hubConnection.createHubProxy("geomapHub");
        this._tabId = tabId;
    }

    getId = () => {
        return this._hubConnection.id;
    }

    start = (callback?: () => void) => {
        if (this._tabId != null)
            this._hubConnection.qs = { tabId: this._tabId };
        return this._hubConnection.start(callback);
    }

    stop = () => {
        if (!this.isDisconnected()) {
            this._hubConnection.stop();
        }
    }

    registerCallback = (methodName: string, callback: (...args: any[]) => any) => {
        this._hubProxy.on(methodName, callback);
    }

    removeCallback = (methodName: string, callback: (...args: any[]) => any) => {
        this._hubProxy.off(methodName, callback);
    }

    addPoint = (point: PointInfo, tab: string, routeId?: number) => {
        return this._hubProxy.invoke("addPoint", point, tab, routeId);
    }

    registerRoutes = (routes: Array<{ routeId: number, name: string }>) => {
        return this._hubProxy.invoke("registerRoutes", routes);
    }

    getRouteOrTabCount = () => {
        return this._hubProxy.invoke("getRouteOrTabCount");
    }

    isDisconnected = () => {
        return (this._hubConnection.state === $.signalR.connectionState.disconnected);
    }

    setStandardRoute = (ressNr: string, start: Date, end: Date, userName: string, language: number) => {
        return this._hubProxy.invoke("setStandardRoute", ressNr, start, end, userName, language);
    }
    
    setSlotStandardRoute  = (fromHome: boolean, backHome: boolean, from: string, sourceId: string, back: string, ressNr: string, userName: string, language: number): JQueryPromise<any> => {
        return this._hubProxy.invoke("setSlotStandardRoute", fromHome, backHome, from, sourceId, back, ressNr, userName, language);
    }
    
    
    setAssignmentAsStandardRoute = (projNr: string, pIndex: number, userName: string, language: number): JQueryPromise<any> => {
        return this._hubProxy.invoke("setAssignmentAsStandardRoute", projNr, pIndex, userName, language);
    }

    setAssignmentRouteAsStandardRoute = (projNr: string, pIndex: number, userName: string, language: number): JQueryPromise<any> => {
        return this._hubProxy.invoke("setAssignmentRouteAsStandardRoute", projNr, pIndex, userName, language);
    }

    addActiveResourceAssignmentsContainer = (start: DayPilot.Date, end?: DayPilot.Date): JQueryPromise<any> => {
        return this._hubProxy.invoke("addActiveResourceAssignmentsContainer", start, end);
    }

    markRouteByRessNr = (ressNr: string) => {
        return this._hubProxy.invoke("markRouteByRessNr", ressNr);
    }

    removeRouteMarking = () => {
        return this._hubProxy.invoke("removeRouteMarking");
    }

    sendRouteColors = (colors: Array<RouteColors>) => {
        return this._hubProxy.invoke("sendRouteColors", colors);
    }

    updateResourceRoutes = (resourceIDs: Array<string>, start: Date, end: Date, groups: Array<string>) => {
        return this._hubProxy.invoke("updateResourceRoutes", resourceIDs, start, end, groups);
    }
}

export interface RouteColors {
    ressNr: string;
    color: string;
}
